import {_axios as axios} from  "../../plugins/axios.js";
import kit from "../../plugins/kit.js"

import { Message, MessageBox  } from "element-ui";
import i18nKit from "../../plugins/I18N.js"
import Auth from "../../plugins/auth.js"
import {dicts} from "../../plugins/dict.js";

let api = kit.api;
let i18n = i18nKit.methods;
let auth = Auth.methods;


/**
 * 一键发货
 * @param {*} stockIds array
 * @returns 
 */
export const batchSendOrderNew = function(stockIds){
    if(stockIds.length == 0){
        Message(i18n.msg('请选中一条数据进行操作'));
        return;
    }
    if(stockIds.length > 500){
        Message(i18n.msg('单次一键发货的数量不能超过五百'));
        return;
    }

    // console.log("执行一键发货")
    MessageBox.confirm(i18n.msg('确定要将选中的订单全部发货吗'), i18n.msg('提示'), {
        confirmButtonText: i18n.msg('确定'),
        cancelButtonText: i18n.msg('取消'),
        type: 'warning'
    }).then(() => {

        MessageBox.confirm(i18n.msg('即将进行发货获取面单操作，是否继续？'), i18n.msg('发货确认'), {
            confirmButtonText: i18n.msg('继续'),
            cancelButtonText: i18n.msg('取消'),
            type: 'warning'
        }).then(() => {
            axios.post(
                api.stock.batchSendOrderNew, 
                stockIds.join(",")
            ).then((result) => {
                if(result.status){
                    Message(result.msg || i18n.msg('更新成功'));
                }else{
                    Message(result.msg || i18n.msg('更新失败'));
                }
            });
        }).catch((err) => {
            // console.log(err);
        });

    }).catch((err) => {
        // console.log(err);
    });
}

/**
 * 
 * @param stockIds array'
 * @param finish 执行成功后的回调函数
 */
export const trackExpress = function(stockIds, finish){
    if(stockIds.length==0){
        Message(i18n.msg('请选中一条数据进行操作'));
        return;
    }
    if(stockIds.length>500){
        Message(i18n.msg('快递同步每次只能同步500条数据'));
        return;
    }
    axios.post(
        api.stock.doTrackExpress, 
        stockIds.join(",")
    ).then((result) => {
        if(result.status){
            let data = result.data;
            let orders = [];
            data.forEach(e => {
                let order = {
                    id:e.purchaseCode,
                    type:e.purchasePlatform
                }
                orders.push(order);
            })
            if(orders.length > 0){
                // console.log("开始同步快递单号", orders);
                window.OKK_Orders.queryTrackingNumber(orders, function(result){
                    // console.log(result);
                    if(result && result.length > 0){
                        let param = [];
                        for (let i = 0; i < data.length; i++) {
                            const e = data[i];
                            let expCode = null;
                            for (let j = 0; j < result.length; j++) {
                                if(result[j] && result[j][0]){
                                    const f = result[j][0];
                                    let purCode = f.id;
                                    if(e.purchaseCode == purCode){
                                        expCode = f.mailNo;
                                    }
                                }
                            }
                            if(expCode){
                                let para = {
                                    id:e.id,
                                    innerExpCode:expCode
                                };
                                param.push(para);
                            }
                        }
                        if(param.length > 0){
                            axios.post(
                                api.stock.doSaveInnerExpCode, 
                                param
                            ).then((result) => {
                                if(result.status){
                                    if(finish) finish();
                                    Message(i18n.msg('同步完成'));
                                }
                            })
                        }else{
                            if(finish) finish()
                            Message(i18n.msg('同步完成'));
                        }
                    }
                })
            }
        }else{
            Message(i18n.msg('不需要同步'));
        }
    })
}

export const doUpdatePkgType = (type, stockIds, callback) => {//type==1货运代打包,type==2跨仓合并包
    if(stockIds==0){
        Message(i18n.msg('请选中一条数据进行操作'));
        return;
    }
    if(stockIds.length>2000){
        Message(i18n.msg('单次操作数据不能大于两千'));
        return;
    }
    if(type == 1){
        axios.post(api.stock.getStockByIds, 
            stockIds.join(",")
        ).then((result) => {
            for(let i=0;i<result.data.length;i++){
                let select = result.data[i];
                if(select.isCancel == 1){
                    Message(select.code + i18n.msg('已取消，不能进行操作'));
                    return;
                }
                if(select.expPkgType != 1 && select.expPkgType != 5){
                    Message(select.code + i18n.msg('不是自行打包，不能进行代打包操作'));
                    return;
                }
            }

            MessageBox.confirm(i18n.msg('是否要通知货运代打包?'), i18n.msg('提示'), {
                confirmButtonText: i18n.msg('确定'),
                cancelButtonText: i18n.msg('取消'),
                type: 'warning'
            }).then(() => {
                try{
                    if(callback){
                        callback();
                    }
                }catch(err){
                    console.log(err);
                }
            }).catch((err) => {
                Message(i18n.msg('取消操作'));
            });

            
        
        })
    }else{
        //跨仓合并包
        MessageBox.confirm(i18n.msg('是否要将订单打包类型转为跨仓合并包?'), i18n.msg('提示'), {
            confirmButtonText: i18n.msg('是'),
            cancelButtonText: i18n.msg('否'),
            type: 'warning'
        }).then(() => {

            // axios.post(api.updateColumn.updatePkgTypeToKuaCang,
            //     stockIds.join(",")
            // ).then((result) => {
            //     if(result.status){
            //         Message(result.msg || i18n.msg('更新成功'));
            //         if(callback) {
            //             callback();
            //         }
            //     }else{
            //         Message(result.msg || i18n.msg('更新失败'));
            //     }
            // })

            try{
                if(callback){
                    callback();
                }
            }catch(err){
                console.log(err);
            }

        }).catch((err) => {
                Message(i18n.msg('取消操作'));
        });
    }
}

//仓储贴单
export const updateOutType = (stockIds, successCallback) => {
    if(stockIds && stockIds.length==0){
        Message(i18n.msg('请选中一条数据进行操作'));
        return;
    }

    MessageBox.confirm(i18n.msg('确定将选中数据更新为仓储贴单吗?'), i18n.msg('提示'), {
        confirmButtonText: i18n.msg('确定'),
        cancelButtonText: i18n.msg('取消'),
        type: 'warning'
    }).then(() => {
        axios.post(api.updateColumn.updateOutType
            +'?ids='+stockIds.join(",")
        ).then((result) => {
            if(result.status){
                Message(result.msg || i18n.msg('更新成功'));
                if(successCallback){
                    successCallback();
                }
            }else{
                Message(result.msg || i18n.msg('更新失败'));
            }
        });
    }).catch((err) => {
         Message(i18n.msg('取消操作'));
    });
}


//打包完成
export const finishPakage = (stockIds, successCallback) => {
    if(stockIds && stockIds.length==0){
        Message(i18n.msg('请选中一条数据进行操作'));
        return;
    }
    MessageBox.confirm(i18n.msg('确定将选中数据更新为打包完成吗?'), i18n.msg('提示'), {
        confirmButtonText: i18n.msg('确定'),
        cancelButtonText: i18n.msg('取消'),
        type: 'warning'
    }).then(() => {
        axios.post(api.stock.finishPackage
            +'?ids='+stockIds.join(",")
        ).then((result) => {
            Message(result.msg || i18n.msg('更新成功'));
            if(successCallback){
                successCallback();
            }
        });
    }).catch((err) => {
        // console.log(err);
    });
}

/**
 * 更改定的货物类型
 * @param {*} command 
 * @param {*} stockIds 
 * @param {*} successCallback 
 * @returns 
 */
export const markOrderGoodType = (command, stockIds, successCallback) => {
    if(stockIds && stockIds.length==0){
        Message(i18n.msg('请选中一条数据进行操作'));
        return;
    }

    let label = dicts.stockExpGoodType[command].label
    let msg = "确定将选中数据标记为"+label+"吗?";
    
    MessageBox.confirm(i18n.msg(msg), i18n.msg('提示'), {
        confirmButtonText: i18n.msg('确定'),
        cancelButtonText: i18n.msg('取消'),
        type: 'warning'
    }).then(() => {
        axios.post(api.updateColumn.updateGoodType
            +'?ids='+stockIds.join(",")
            +'&value='+command
        ).then((result) => {
            if(result.status){
                Message(result.msg || i18n.msg('更新成功'));
                if(successCallback){
                    successCallback();
                }
            }else{
                Message(result.msg || i18n.msg('更新失败'));
            }
        });
    }).catch((err) => {
        // console.log(err);
    });
}

/**
 * post方式提交数据并在新窗口打开
 * @param {} url 
 * @param {*} data 
 */
export const openWindowWithPost = (url, data) => {
    var form = document.createElement("form");
    form.target = "_blank";
    form.method = "POST";
    form.action = url;
    form.style.display = "none";

    for (var key in data) {
        var input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = data[key];
        form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
}

/**
 * 删除订单
 * @param {*} stockIds string "1,2,3"
 */
export const deleteStock = (stockIds, callback)=>{

    MessageBox.confirm('确定要删除选择的订单吗?', i18n.msg('提示'), {
        confirmButtonText: i18n.msg('确定'),
        cancelButtonText: i18n.msg('取消'),
        type: 'warning'
    }).then(() => {
        axios.post(api.stock.delete, stockIds)
        .then((result) => {
            if(result.status){
                if(callback){
                    callback();
                }
                let oks = result.data.oks;
                let errs = result.data.errs;
                MessageBox(i18n.msg('删除成功')+"："+oks+"条，"+i18n.msg('删除失败')+"："+errs+"条" );
            }else{
                MessageBox(result.msg);
            }
        });
    }).catch((err) => {
        // console.log(err);
    });

}

export function formatAmt(value){
    try{
        return parseFloat((value/100).toFixed(2));
    }catch(err){
        return value;
    }
}

export function formatWeight(value){
    try{
        return parseFloat((value/1000).toFixed(3));
    }catch(err){
        return value;
    }
}

export function formatVolume(value){
    try{
        return parseFloat((value/1000).toFixed(3));
    }catch(err){
        return value;
    }
}

export function readyQueryParam(refresh, query, originCols, isStore){
    // console.log("get list: "+refresh);
    if(refresh){
        query.pageIndex = 1;
        query.start = 0;
        query.pageTotal = 0;//this.query.length;
        // console.log("pageTotal", this.query.length+"-"+this.query.pageTotal);
        
    }

    query.store = isStore;
    var params = kit.rebuildQuery(query);
    params['columns'] = originCols;

    //获取查询的数，并且过滤掉空数据，
    let queries = []; 
    query.queries.forEach(e => {
            let values = e.dvalues;
            let value = e.dvalue;
            let q = {
                dvalue: e.dvalue,
                tableName: e.tableName,
                colName: e.colName,
                op: e.op,
                type: e.type,
                tableAlias: e.tableAlias,
                optType: e.optType || 0
            }

            if(q.type == 0 && q.op == 6){
                if(value){
                    value = value.split(/[\s,]+/);
                    q.dvalue = value.join(",");
                    queries.push(q);
                }
            }else{
                if(q.type == 3 || q.op == 6 || q.op==8 || q.type == 4){
                    if(values && values.length>0){
                        q.dvalue = values.join(",");
                        queries.push(q);
                    }
                }else if(q.dvalue || q.dvalue === 0){
                    queries.push(q);
                }
            }
        });
    params['queries'] = queries;

    return params;
}


/**
 * 获取stock数据
 */
export const getStocks = async (params, queryHistory) => {
   
    let result = await axios.post( api.stock.list, params);

    let list = null;
    if(result.status){
        list  = result.data.list;
            
        list.forEach(row => {
            for(let colName in row){
                //weightInputer
                let lowerCol = colName.toLowerCase();
                let val = row[colName];
                if(val){  //这里格式化根据单位进行转换
                    if(colName.indexOf("weight") >-1){

                        let isWeight = colName.indexOf("weightExp")>-1 
                            || colName.indexOf("weightPkg")>-1
                            || colName.indexOf("weightCustPkg")>-1
                            || colName.indexOf("weightConsign")>-1
                            || colName.indexOf("weightGross")>-1
                            || colName.indexOf("weightAvg")>-1
                            || colName.indexOf("weightCheck")>-1
                        if(isWeight){
                            row[colName] = formatWeight(val);
                        }
                    }else if( colName.indexOf('price')>-1 || colName.indexOf("amt") > -1 || lowerCol.indexOf('rate')>-1){
                        row[colName] = formatAmt(val)
                    }else if(lowerCol=="product_volume" || lowerCol=="productvolume"){
                        row[colName] = formatVolume(val)
                    }else if(lowerCol=="offline_amount" || lowerCol=="offlineamount"){
                        row[colName] = formatAmt(val)
                    }
                }
            }
            
            row.queryHistory = queryHistory;

        });
    }

    return list;
}